import Div from "@jumbo/shared/Div/Div";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import {Suspense} from "react";
import CreateMatter from "./CreateMatter";


const CreateMatterModal = ({open, handleClose}) => (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Div
            sx={{
                justifyContent: "flex-start !important"
            }}
            className="customize-modal preview-form"
        >
            <div className="modal-head">
                <h2>&nbsp;</h2>
                <IconButton className="close-modal-btn p-0" onClick={handleClose}>
                    <HighlightOffIcon/>
                </IconButton>
            </div>
            <Div className="modal-body-content">
                <Suspense
                    fallback={
                        <Div
                            sx={{
                                display: "flex",
                                minWidth: 0,
                                alignItems: "center",
                                alignContent: "center",
                                height: "100%"
                            }}
                        >
                            <CircularProgress sx={{m: "-40px auto 0"}}/>
                        </Div>
                    }
                >
                    <CreateMatter handleClose={handleClose}/>
                </Suspense>
            </Div>
        </Div>
    </Modal>
);


export default CreateMatterModal;